
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
	MatNativeDateModule,
	NativeDateAdapter,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { SatDatepickerComponent } from './component/picker/sat-datepicker.component';
import { SatDatepickerInputDirective } from './directive/sat-datepicker-input.directive';
import { SatDatepickerToggleComponent } from './component/toggle/sat-datepicker-toggle.component';

export { SatDatepickerInputEvent, SatDatepickerRangeValue } from './event/sat-datepicker-input-event';
export type SatDatepicker<D = any> = SatDatepickerComponent;
export { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, NativeDateAdapter };

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		MatDatepickerModule,
		MatIconModule,
		MatButtonModule,
	],
	declarations: [
		SatDatepickerComponent,
		SatDatepickerToggleComponent,
		SatDatepickerInputDirective,
	],
	exports: [
		SatDatepickerComponent,
		SatDatepickerToggleComponent,
		SatDatepickerInputDirective,
	],
})
export class SatDatepickerModule {}

@NgModule({
	imports: [MatNativeDateModule],
	exports: [MatNativeDateModule],
})
export class SatNativeDateModule {}
